import { api } from "@/api/api";
import {
  PurchaseStatus,
  type PaymentResult,
  type StandardPaymentProvider,
} from "@/app/payments/types";
import type { CreateOrderOutputDto } from "@/types/codegen";

import { constructOrderApiParams } from "./utils";

const provider = "SUPER_QI_APP";

export const superQiPaymentProvider: StandardPaymentProvider = {
  initiatePayment: async ({ onSuccess, onFailure, ...params }) => {
    const { apiUrl, apiParams } = constructOrderApiParams(params);
    const response = await api.post<CreateOrderOutputDto>(apiUrl, {
      ...apiParams,
      provider,
    });

    const paymentUrl = response?.data?.data?.superQiSession?.redirectUrl;
    const orderId = response?.data?.data?.superQiSession?.orderId;

    if (!paymentUrl || !orderId) {
      onFailure({
        orderId,
        errorType: "InvalidResponse",
        errorMessage: "Missing redirect action form",
      });

      throw new Error(
        "Invalid response from API: Missing redirect action form",
      );
    }

    return new Promise<PaymentResult>((resolve, reject) => {
      // https://miniprogram.alipay.com/docs/miniprogram/mpdev/API_OpenAPI_tradePay
      my?.tradePay({
        paymentUrl,
        success: (res) => {
          switch (res.resultCode) {
            case "9000": // Payment is successful
              onSuccess({ orderId });

              resolve({
                orderId,
                status: PurchaseStatus.SUCCESSFUL,
              });
              break;

            case "6001": // User cancels to pay
              onFailure({
                orderId,
                errorType: "UserCancelled",
                errorMessage: "User cancelled the payment",
              });

              resolve({
                orderId,
                status: PurchaseStatus.CANCELLED,
              });
              break;

            default:
              onFailure({
                orderId,
                errorType: "UnsupportedResultCode",
                errorMessage: `SuperQi payment failed, unsupported result code: ${res.resultCode}`,
              });

              reject(
                new Error(
                  `SuperQi payment failed, unsupported result code: ${res.resultCode}`,
                  { cause: res },
                ),
              );
              break;
          }
        },
        fail: (err) => {
          onFailure({
            orderId,
            errorType: "PaymentFailed",
            errorMessage: `SuperQi payment failed with code ${err.error}, message: ${err.errorMessage}`,
          });

          reject(
            new Error(
              `SuperQi payment failed with code ${err.error}, message: ${err.errorMessage}`,
              { cause: err },
            ),
          );
        },
      });
    });
  },
};
